import { render, staticRenderFns } from "./content-menu-editor.vue?vue&type=template&id=63b8630c&scoped=true"
import script from "./content-menu-editor.vue?vue&type=script&lang=js"
export * from "./content-menu-editor.vue?vue&type=script&lang=js"
import style0 from "./content-menu-editor.vue?vue&type=style&index=0&id=63b8630c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8630c",
  null
  
)

export default component.exports